import BaseApi from './BaseApi'

export default {
  index(params = {}) {
    return BaseApi.get('/v1/regions', {
      params: {
        'filter[type]': params.type,
        'filter[country_code]': params.country_code,
        'filter[state_code]': params.state_code,
      },
    })
  },

  findCountry(query) {
    return BaseApi.get('/v1/regions', {
      params: {
        'filter[type]': 'COUNTRY',
        'filter[country]': query,
      },
    })
  },
}
